import axios from "axios";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

// Renouvelle la session automatiquement si elle a expiré
http.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  if (error?.response?.status === 401 && cfg && !cfg._retried && !cfg.url?.includes("/auth/")) {
    cfg._retried = true;
    try {
      await http.post("/auth/refresh");
      return http(cfg);
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Une erreur est survenue.";
};
